<template>
   <div>
      <div class="row">
         <div class="col-12 text-center">
            <h3 class="mb-3">{{ title }}</h3>
            <h4 class="mb-4">{{ denomination }}</h4>
         </div>
      </div>
      <div class="row">
         <div class="col-12" v-html="content"></div>
      </div>
   </div>
</template>

<script>
import axios from 'axios'
export default {
   name: "processes-detail-process-task-rule-detail-view",
   props: ["data"],
	data () {
		return {
         title: '',
         denomination: '',
         content: ''
      }
   },
	methods: {
		initProcessTaskRuleDetailView: function() {
         axios.post('/auth/processes/getComplianceRuleDetailView', {
            normId: this.data.id,
         }).then(response => {
            this.title = response.data.titulo;
            this.denomination = response.data.denominacion;
            this.content = response.data.contenido;
         });
      }
	},
	created: function() {
    this.initProcessTaskRuleDetailView();
  }
}
</script>